import React, {PropTypes} from 'react';
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch
} from 'react-router-dom'

import moment from 'moment';
import numeral from 'numeral';
// SHARED
import muiTheme from '../../utils/muiTheme'
import BackNavLink from '../../core/components/BackNavLink'
import DocumentIcon from '../../core/components/DocumentIcon'
import DateRangePopover from '../../core/components/DateRangePopover'
import { Slider, Select, Button, Col, Row, Popconfirm } from 'antd';
import Card, { TitleCard, CardHeader } from '../../core/Card'
import Line from '../../core/Line'
import './MemberMainContent.css'

const Option = Select.Option;

const svgStyleGreen ={
  fill: "#31b59f",
  width: "25px",
  height: "25px"
}
const svgStyleWhite ={
  fill: "#ffffff",
  width: "25px",
  height: "25px"
}

const MemberMainContent = ({isFetching, kms_enabled, onFileTypeChange, onDateChange, userProfile, handleSendReport, selectedDates, file_type, mType, onRemove, onClickGetReport}) =>
  <div className="MemberMainContent">
    <TitleCard showBackButton>
      <h1>{userProfile.name} {userProfile.last} {userProfile.email}</h1>

        <Button type="primary" onClick={()=>onClickGetReport(userProfile.email)}>
          Get Report
        </Button>

      { onRemove &&
        <Popconfirm title="Are you sure you want to remove this user from your group?" placement="left" onConfirm={onRemove} okText="Yes" cancelText="No">
          <Button type="danger" icon="delete"></Button>
        </Popconfirm>
        }

    </TitleCard>
    <Card showLoadingIcon={isFetching} hideContent={isFetching}>
      <CardHeader
        title="Mileage Totals"
      />
      <Row className="total-row work" type="flex" justify="center">
        <Col xs={12} sm={6} md={6}>
          <p>Work:</p>
        </Col>
        <Col xs={12} sm={6} md={6}>
          <p>{numeral(userProfile['total_business_'+mType]).format('0,0.0')} {mType}</p>
        </Col>
      </Row>
      <Row className="total-row unclassified" type="flex" justify="center">
        <Col xs={12} sm={6} md={6}>
          <p>Unclassified:</p>
        </Col>
        <Col xs={12} sm={6} md={6}>
          <p>{numeral(userProfile['total_uncategorized_'+mType]).format('0,0.0')} {mType}</p>
        </Col>
      </Row>

    </Card>
    <Card>
      <CardHeader
        title="Transactions Totals"
      />
      <Row className="total-row expenses" type="flex" justify="center">
        <Col xs={12} sm={6} md={6}>
          <p>Expenses:</p>
        </Col>
        <Col xs={12} sm={6} md={6}>
          <p>{numeral(userProfile.total_expenses).format('$0,0.0')}</p>
        </Col>
      </Row>

    </Card>

  </div>



export default MemberMainContent



// WEBPACK FOOTER //
// ./src/enterprise/members/MemberMainContent.js